<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.demandName"
              placeholder="请输入需求原因"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col
            :span="5"
            style="text-align: right;"
          >
            <el-button
              type="primary"
              @click="createOutdepotFun()"
            >
              创建出库单
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          :multiple-selection.sync="multipleSelection"
          @reloadData="loadTableData(tableList)"
          @createOutdepot="createOutdepotFun()"
        />
      </div>

      <!-- 新增 -->
      <add-edit-task-dialog
        :event-type="'add'"
        :send-array="selectObjects"
        :outdepot-type="type"
        :dialog-title="dialogAddEditTitle"
        :dialog-visible.sync="dialogAddEditVisible"
        :master-table-key="tableList.tableKey"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 新增 修改
import addEditTaskDialog from './addEditTaskDialog'
import { loadMaterialsDemandListDataApi } from '@/api/materialsDemandDetail'

export default {
  name: 'MaterialsTodoTransferList',
  components: { CustomTable, addEditTaskDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    sourceType: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'materials_todo_transfer_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'add',
            label: '创建出库单',
            method: 'createOutdepot'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            demandName: '',
            materialsName: '',
            todoTransfer: 'true',
          }
        }
      },
      isPaging: true,
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      type: 13, // 出库类型-调拨出库
      multipleSelection: [],
      selectObjects: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 90 },
          { prop: 'cityName', label: '市场', filterColumn: 'city_name', width: 80 },
          { prop: 'schemeNo', label: '方案编号', filterColumn: 'scheme_no', width: 200 },
          { prop: 'schemeContent', label: '需求来源', filterColumn: 'scheme_content', width: 180 },
          { prop: 'demandSide', label: '需求方', filterColumn: 'demand_side', width: 100 },
          { prop: 'auditAllocateDepotName', label: '调出库房', filterColumn: 'audit_allocate_depot_name', width: 110 },
          { prop: 'materialsName', label: '物料名称', filterColumn: 'materials_name' },
          { prop: 'materialsUnitName', label: '物料单位', filterColumn: 'materials_unit_name', width: 105 },
          { prop: 'auditAllocateNumber', label: '待调出数量', filterColumn: 'audit_allocate_number', width: 120 }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.search.sourceType = this.sourceType
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      this.tableList.tableQuery.sort.order = ''
      loadMaterialsDemandListDataApi({ condition: JSON.stringify(this.tableList.tableQuery) }).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data || []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 创建出库单
    createOutdepotFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({ message: '请选择要调拨出库的物料', type: 'warning' })
        return false
      } else {
        let depotId = null
        let isSame = true
        let transferDepotId = null
        let sameTransferDepot = true
        this.multipleSelection.forEach(item => {
          if (depotId === null) {
            depotId = item.auditAllocateDepotId
          } else if (depotId !== item.auditAllocateDepotId) {
            isSame = false
          }
          if (transferDepotId === null) {
            transferDepotId = item.receiveDepotId
          } else if (transferDepotId !== item.receiveDepotId) {
            sameTransferDepot = false
          }
          item.sourceType = 1
          item.sourceTypeStr = '自制'
        })
        if (!isSame) {
          this.$message({ message: '请选择相同调出库房的物料', type: 'warning' })
          return false
        }
        if (!sameTransferDepot) {
          this.$message({ message: '请选择相同调入库房的物料', type: 'warning' })
          return false
        }
        this.selectObjects = this.multipleSelection
        this.dialogAddEditTitle = '新增出库单'
        this.dialogAddEditVisible = !this.dialogAddEditVisible
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
